module.exports = __webpack_public_path__ + "static/media/Rectangle 12896.5804c056.png";